// Copyright (c) Microsoft Corporation. All rights reserved.
/**
 * Mouse connected status changed event.
 */
export class MouseConnectedStatusChangedEvent extends Event {
    constructor() {
        super(MouseConnectedStatusChangedEvent.type);
    }
}
MouseConnectedStatusChangedEvent.type = 'mouseConnectedStatusChanged';
//# sourceMappingURL=MouseConnectedStatusChangedEvent.js.map